/* eslint-disable jsx-a11y/anchor-is-valid */
import { Row } from "antd";
import { withTranslation } from "react-i18next";
import Container from "../../common/Container";
import {
  HeaderSection,
  LogoContainer,
  NotHidden,
} from "./styles";
import { Link } from "react-router-dom";

const Header = ({ t }: any) => {

  const MenuItem = ({ isDrawer = false, isMobile = false }) => {
    return (
      <div
        style={
          isDrawer
            ? {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "16px",
                padding: "1rem"
              }
            : isMobile
            ? {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "12px"
              }
            : {
                display: "flex",
                alignItems: "center",
                gap: "12px"
              }
        }
      >
        <a 
          href="https://apps.apple.com/us/app/pureple-outfit-planner/id628106373"
          style={{
            transition: "all 0.2s ease",
            borderRadius: "8px",
            overflow: "hidden",
            display: "block",
            opacity: "0.9"
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.opacity = "1";
            e.currentTarget.style.transform = "translateY(-1px)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.opacity = "0.9";
            e.currentTarget.style.transform = "translateY(0)";
          }}
        >
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg"
            style={{ 
              height: "48px",
              borderRadius: "6px",
              display: "block"
            }}
            alt="Download Pureple AI Outfit Planner on App Store for iPhone and iPad"
          />
        </a>
        <a 
          href="https://play.google.com/store/apps/details?id=com.app.pureple"
          style={{
            transition: "all 0.2s ease",
            borderRadius: "8px",
            overflow: "hidden",
            display: "block",
            opacity: "0.9"
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.opacity = "1";
            e.currentTarget.style.transform = "translateY(-1px)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.opacity = "0.9";
            e.currentTarget.style.transform = "translateY(0)";
          }}
        >
          <img
            src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
            style={{ 
              height: "48px",
              borderRadius: "6px",
              display: "block"
            }}
            alt="Get Pureple AI Outfit Planner on Google Play for Android devices"
          />
        </a>
        <a 
          href="https://discord.gg/5mW38wthDe"
          style={{
            transition: "all 0.2s ease",
            borderRadius: "8px",
            overflow: "hidden",
            display: "block",
            opacity: "0.9"
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.opacity = "1";
            e.currentTarget.style.transform = "translateY(-1px)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.opacity = "0.9";
            e.currentTarget.style.transform = "translateY(0)";
          }}
        >
          <div
            style={{
              background: "#5865F2",
              height: "48px",
              width: "120px",
              borderRadius: "6px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              color: "white",
              fontSize: "11px",
              fontWeight: 600,
              lineHeight: "1.1",
              textAlign: "center"
            }}
          >
            <div>join us</div>
            <div>on discord</div>
          </div>
        </a>
      </div>
    );
  };

  return (
    <HeaderSection>
      <Container>
        {/* Desktop Layout */}
        <Row justify="space-between" className="desktop-header">
          <LogoContainer to="/" aria-label="homepage">
            <div>
              <h2>Pureple</h2>
            </div>
          </LogoContainer>
          <NotHidden>
            <MenuItem />
          </NotHidden>
        </Row>

        {/* Mobile Layout */}
        <div className="mobile-header">
          <Row justify="center" style={{ marginBottom: "1rem" }}>
            <LogoContainer to="/" aria-label="homepage">
              <div>
                <h2>Pureple</h2>
              </div>
            </LogoContainer>
          </Row>
          <Row justify="center">
            <div className="mobile-buttons">
              <MenuItem isMobile />
            </div>
          </Row>
        </div>


      </Container>
    </HeaderSection>
  );
};

export default withTranslation()(Header);
